import React from 'react'
import { CGE } from '../../../../common/components/CGE'

function ModalContentEdit({setForm,form,validForm,obj}) {

    const objStyleDisalbed = { border: '2px solid lightgray', backgroundColor: 'lightgray', cursor: 'not-allowed' };

  return (
    <CGE.PanelSectionTicket title="Datos de la cuenta">
        <div className="row">
            <div className="col-md-12">
                <CGE.FormsField
                    idFormElement="inputNumCli"
                    readOnly={true}
                    typeElement="input"
                    typeFormElement="text"
                    labelName="Nro Cliente:"
                    placeholder="Nro Cliente"
                    value={obj?.CTA_CTO}
                    style={objStyleDisalbed}
                />
            </div>
            <div className="col-md-12">
                <CGE.FormsField
                    handleChange={(e) => setForm({...form,name:e.target.value })}
                    idFormElement="inputName"
                    typeElement="input"
                    typeFormElement="text"
                    labelName="Nombre Cuenta:"
                    placeholder="Nombre Cuenta"
                    hasError={validForm?.validateName}
                    msgError={validForm?.msgName && validForm?.validateName?validForm?.msgName:""}
                    value={form?.name}
                />
            </div>
            <div className="col-md-12">
                <CGE.FormsField
                    idFormElement="inputState"
                    readOnly={true}
                    typeElement="input"
                    typeFormElement="text"
                    labelName="Estado:"
                    placeholder="Estado"
                    value={obj?.ESTADO_SERVICIO}
                    style={objStyleDisalbed}
                />
            </div>
        </div>
    </CGE.PanelSectionTicket>

  )
}
export default ModalContentEdit;
